module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAYAAAD+4+QTAAAACXBIWXMAAAsSAAALEgHS3X78AAAA9ElEQVRIibXWPQ6CMBjG8T8GnBy4gLNbmR0cZNbJ3bg6eSXjCYzsbB4Ar8AFSByJwYFOxA+eF32SDm0Kv7R52zRomgY1UZLuAOoiP/aZH6hIlKQXYOG7d8DVRV59+mYkCW3WQOzbFLhFSRr/Gsk6/a+QBdkCpQLJiN9/p0CWlciQCVEhM6JAQeiWMbCjLUlrYuDwYrwEXAicgTkwHoC8yxQ4BaFb6veKmBFwBR5/NLIQWAF7YDbgRxNg82K8BLbyBdmNr6Ab7f53AVcXeTWohPsAMOCc9AXMiAKYEBUwIcBJAazIWgGsSAZUvn0FwPCQAP218gSu53K1tBln0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/complete_step_disable.png
// module id = Lhv0
// module chunks = 0